import { render, staticRenderFns } from "./StepUp.vue?vue&type=template&id=776f7154&scoped=true&"
import script from "./StepUp.vue?vue&type=script&lang=ts&"
export * from "./StepUp.vue?vue&type=script&lang=ts&"
import style0 from "./StepUp.vue?vue&type=style&index=0&id=776f7154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776f7154",
  null
  
)

export default component.exports